import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useMemo } from 'react';
import { ProfessionalMyPageIntroductionCompleteView } from '@/components/pages/mypage/professional/ProfessionalMyPageIntroduction/ProfessionalMyPageIntroductionCompleteView';
import { useTypeSelector } from '@/hooks/state/useTypeSelector';
import { isClient } from '@/utils/resources/auth/authResource';
import { getFullName, getOrganizationName, getPosition, isCanUseProfessionalProffit, isCanUseProfessionalProffitMart, } from '@/utils/resources/profile/profileResource';
export const ProfessionalMyPageIntroductionComplete = (props) => {
    const { profile } = props;
    const { auth } = useTypeSelector((rootState) => ({
        auth: rootState.auth,
    }));
    const user = useMemo(() => {
        var _a;
        return ({
            fullName: getFullName(profile),
            image: (_a = profile.information) === null || _a === void 0 ? void 0 : _a.file,
            isUseProffit: isCanUseProfessionalProffit(profile),
            isUseProffitMart: isCanUseProfessionalProffitMart(profile),
            organizationName: getOrganizationName(profile),
            position: getPosition(profile, isClient(auth)),
        });
    }, [auth, profile]);
    return _jsx(ProfessionalMyPageIntroductionCompleteView, { user: user });
};
